var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2218 9.33333V17.1556C18.2218 18.1512 18.2218 18.649 18.028 19.0293C17.8576 19.3638 17.5856 19.6358 17.2511 19.8062C16.8708 20 16.373 20 15.3773 20H8.62179C7.62614 20 7.12831 20 6.74803 19.8062C6.41352 19.6358 6.14155 19.3638 5.97111 19.0293C5.77734 18.649 5.77734 18.1512 5.77734 17.1556V6.84444C5.77734 5.8488 5.77734 5.35097 5.97111 4.97068C6.14155 4.63617 6.41352 4.36421 6.74803 4.19377C7.12831 4 7.62614 4 8.62179 4H12.8885M18.2218 9.33333L12.8885 4M18.2218 9.33333H13.7773C13.2864 9.33333 12.8885 8.93536 12.8885 8.44444V4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFile;